import { Component, OnInit } from "@angular/core";
import { Message } from "../../Model/System/Message";
import { TestResult } from "../../Model/Dto/TestResult";

import { ModelService } from '../../Services/model.service';
import { SendToNWConfig } from '../../Model/Dto/SendToNWConfig';




@Component({
    selector: "recurringJobs",
    templateUrl: "recurringJobs.component.html",
    standalone: false
})
export class RecurringJobsComponent{

  tabs = [
    { id: 1, title: "Jobs", template: "jobsTemplate" },
    { id: 2, title: "FTP Server", template: "ftpServerTemplate" }
  ];
  jobs = [];

  constructor(public modelService: ModelService) {
    this.jobs = [
      { id: 1, title: "FTP Import", template: "ftpImportJobsTemplate" },
      { id: 2, title: "FTP Export", template: "ftpExportJobsTemplate" },
      { id: 3, title: "FTP SupplierMappingImport", template: "FtpSupplierPidMappingsImportJobsTemplate" },
      { id: 4, title: "FTP Lieferanten Import", template: "FtpDataSourceImportJobsTemplate" },
      { id: 5, title: "URL Import", template: "urlImport" },
      { id: 7, title: "Medien FTP-Export", template: "mediaFtpExportJobsTemplate" }
    ];

    if (this.showHeinzeImport) {
      this.jobs.splice(1, 0, { id: 6, title: "FTP Heinze Import", template: "ftpHeinzeImportJobsTemplate" });
    }

    if (this.modelService.loginService.hasAddonBauvista) {
      this.jobs.push({ id: 8, title: "FotoWare Medienimport", template: "fotoWareImportJobsTemplate" });
    }
  }

  get showHeinzeImport(): boolean {
    return this.modelService.loginService.hasAddonBauvista && this.modelService.loginService.hasAddonDpbImport;
  }
}
